<template>
  <v-col class="ma-0 pa-0 secondary" cols="12">
    <v-chip-group
      dense
      class="ma-0 pa-0"
      active-class="primary white--text"
    >
      <v-icon
        @click="categoryModel = null"
        v-if="
          categoryModel != null || !!this.classesFilter || animalsFilter != null
        "
        color="primary"
        class="ma-0 pa-0 mr-2 vetalfa-pointer"
      >
        {{ mdiCloseCircleOutline }}
      </v-icon>
      <div v-if="!$route.params.topic || $route.params.topic === 'foods'">
        <v-chip
          :outlined="categoryModel != index"
          v-for="(c, index) in filterChipsList"
          @click="categoryModel = categoryModel == index ? null : index"
          class="text-left px-3"
          color="primary"
          :key="`${index} ${c.ptShortName}`"
          v-show="categoryModel == index || categoryModel == null"
          small
        >
          {{ c.ptShortName || c.portugueseName }}
        </v-chip>
      </div>
      <v-chip
        @click.stop="dialogSystemsModel = true"
        v-if="categoryFilter == 1 && (!!systemModel || !classModel)"
        class="vetalfa-text-overflow text-left px-3"
        :outlined="!systemModel"
        color="primary"
        small
      >
        {{ systemsChipName }}
        <v-icon class="ml-1" small>{{ mdiChevronDown }}</v-icon>
      </v-chip>
      <v-chip
        @click.stop="dialogAnimalsModel = true"
        v-if="isNotCategoriesButIsTopics"
        class="vetalfa-text-overflow text-left px-3"
        :outlined="animalsFilter == null"
        color="primary"
        small
      >
        {{ animalsChipName }}
        <v-icon class="ml-1" small>{{ mdiChevronDown }}</v-icon>
      </v-chip>
      <v-chip
        @click.stop="dialogClassModel = true"
        v-if="hasClassesChips"
        class="vetalfa-text-overflow text-left px-3"
        :outlined="!classModel"
        color="primary"
        small
      >
        {{ classesChipName }}
        <v-icon class="ml-1" small>{{ mdiChevronDown }}</v-icon>
      </v-chip>
    </v-chip-group>
    <vetalfa-dialog
      v-on:dialogClose="dialogSystemsModel = false"
      title="Sistemas"
      :toggleModel="dialogSystemsModel"
      :fullscreen="false"
      :featureMode="false"
      v-if="
        !!categoryFilter &&
        !!classesListComputed &&
        !!classesListComputed.length
      "
    >
      <chip-group
        v-if="!!systemsList && !!systemsList.length"
        :clearTrigger="clearTriggerSystem"
        v-on:selectChip="setSystem"
        :items="systemsList"
        :defaultValue="
          !systemFilter ? null : systemsList.indexOf(systemFilter.system)
        "
      ></chip-group>
      <div style="height: 50px; background-color: white"></div>
    </vetalfa-dialog>
    <vetalfa-dialog
      v-on:dialogClose="dialogAnimalsModel = false"
      title="Animais"
      :toggleModel="dialogAnimalsModel"
      :fullscreen="false"
      :featureMode="false"
      v-if="isNotCategoriesButIsTopics"
    >
      <animal-selector
        :clearTrigger="clearTrigger"
        v-on:selectAnimal="selectAnimal"
        plural
        hasBothAnimals
        :defaultValue="animalsFilter"
      >
      </animal-selector>
      <div style="height: 50px; background-color: white"></div>
    </vetalfa-dialog>
    <vetalfa-dialog
      v-on:dialogClose="dialogClassModel = false"
      :title="`Classes${!!systemModel ? ' para ' + systemModel : ''}`"
      :toggleModel="dialogClassModel"
      :fullscreen="categoryFilter == 1 && !systemModel"
      :featureMode="false"
      :height="categoryFilter == 1 && !systemModel ? _getWindowHeight() : null"
      v-if="
        (!!categoryFilter || !!$route.params.topic) &&
        !!classesListComputed &&
        !!classesListComputed.length
      "
    >
      <template v-slot:header>
        <v-text-field
          v-if="categoryFilter == 1 && !systemModel"
          :items="classesListComputed"
          :placeholder="'Pesquise uma classe'"
          v-model="searchCondition"
          :disabled="!!classModel"
          hide-details
          class="pa-2"
          item-color="primary"
          clearable
          outlined
          single-line
          dense
          :prepend-inner-icon="mdiMagnify"
        >
        </v-text-field>
      </template>
      <template>
        <chip-group
          v-if="!!classesListComputed && !!classesListComputed.length"
          :clearTrigger="clearTrigger"
          v-on:selectChip="setClass"
          :items="classesListComputed"
          :defaultValue="classesListComputed.indexOf(classesFilter)"
          :search="searchCondition"
        ></chip-group>
        <div style="height: 50px; background-color: white"></div>
      </template>
    </vetalfa-dialog>
  </v-col>
</template>

<script>
import categories from "@/constants/categories.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { mdiCloseCircleOutline, mdiChevronDown, mdiMagnify } from "@mdi/js";
import AnimalSelector from "@/components/AnimalSelector.vue";
import ChipGroup from "@/components/ChipGroup.vue";
import systemsEnum from "@/constants/systems.enums.js";
export default {
  components: {
    "chip-group": ChipGroup,
    "animal-selector": AnimalSelector,
  },
  watch: {
    classModel(val) {
      this.applyFilters();
      this.$nextTick(() => {
        if (!!val) {
          this.logEvent("chipFiltersClassClick");
          this.dialogClassModel = false;
        } else {
          this.searchCondition = null;
        }
      });
    },
    animalsFilter() {
      this.logEvent("chipFiltersAnimalsClick");
      this.dialogAnimalsModel = false;
    },
    systemModel(val) {
      this.dialogSystemsModel = false;
      if (!this.classModel && !!this.classesFilter) {
        this.classModel = this.classesFilter;
      } else {
        this.clearTrigger = new Date().getTime();
        this.classModel = null;
      }
      if (!val) {
        this.logEvent("chipFiltersSystemsClick");
      }
      this.applyFilters();
    },
  },
  computed: {
    ...mapGetters("drugs", [
      "categoryFilter",
      "classesFilter",
      "systemFilter",
      "classesList",
      "catFilter",
      "dogFilter",
    ]),
    ...mapGetters("preferences", ["preferences"]),
    animalsFilter() {
      if (this.dogFilter && !this.catFilter) return 0;
      else if (!this.dogFilter && this.catFilter) return 1;
      else if (this.dogFilter && this.catFilter) return 2;
      return null;
    },
    hasClassesChips() {
      return (
        this.$route.params.topic !== "foods" &&
        (this.categoryModel != null || !!this.$route.params.topic) &&
        !!this.classesListComputed &&
        !!this.classesListComputed.length
      );
    },
    isNotCategoriesButIsTopics() {
      return (
        !!this.$route.params.topic &&
        !["foods", "oral_hygiene", "supplements"].includes(
          this.$route.params.topic
        )
      );
    },
    filterChipsList() {
      return categories.filter((c) => {
        return (
          this.$route.params.topic !== "foods" ? [1, 2, 4, 5] : [8, 9]
        ).includes(c.id);
      });
    },
    categoryModel: {
      get() {
        let index = null;
        this.filterChipsList.forEach((chip, chipIndex) => {
          if (chip.id == this.categoryFilter) index = chipIndex;
        });
        return index;
      },
      set(val) {
        this.setCategoryFilter(
          val == null ? val : this.filterChipsList[val].id
        );
        if (val != null) {
          this.logEvent("chipFiltersCategoryClick");
        }
        this.$nextTick(() => {
          this.clearTrigger = new Date().getTime();
          this.classModel = null;
          this.systemModel = null;
          this.clearTriggerSystem = new Date().getTime();
          if (!!this.$route.params.topic) {
            this.clearFilters();
            this.$emit("createListOfItems");
          } else {
            this.applyFilters();
          }
        });
      },
    },
    classesListComputed() {
      const distinctClasses = new Set();
      if (!!this.systemModel) {
        return systemsEnum.find((s) => s.system === this.systemModel).classes;
      } else if (!!this.$route.params.topic) {
        return this.classesList;
      } else if (!!this.preferences && !!this.preferences.length) {
        this.preferences.forEach((obj) => {
          if (
            this.categoryFilter != null &&
            obj.category == this.categoryFilter
          ) {
            obj.classes.forEach((cls) => {
              distinctClasses.add(cls.trim());
            });
          }
        });
      }
      return [...distinctClasses].sort();
    },
    systemsList() {
      return systemsEnum.map((item) => item.system).sort();
    },
    classesChipName() {
      return this.classModel || "Classes";
    },
    systemsChipName() {
      return this.systemModel || "Sistemas";
    },
    animalsChipName() {
      return (
        { 0: "Cães", 1: "Gatos", 2: "Cães e Gatos" }[this.animalsFilter] ||
        "Animais"
      );
    },
  },
  mounted() {
    if (!this.systemModel && !!this.systemFilter) {
      this.systemModel = this.systemFilter.system;
    }
    this.$nextTick(() => {
      if (!this.classModel && !!this.classesFilter) {
        this.classModel = this.classesFilter;
      }
    });
  },
  methods: {
    ...mapMutations("drugs", [
      "setCategoryFilter",
      "setClassesFilter",
      "setSystemFilter",
      "setDogFilter",
      "setCatFilter",
    ]),
    ...mapActions("general", ["logEvent"]),
    ...mapActions("drugs", ["clearFilters"]),
    selectAnimal(obj) {
      switch (obj.value) {
        case 0:
          this.setCatFilter(false);
          this.setDogFilter(true);
          break;
        case 1:
          this.setCatFilter(true);
          this.setDogFilter(false);
          break;
        case 2:
          this.setCatFilter(true);
          this.setDogFilter(true);
          break;
        default:
          this.setCatFilter(false);
          this.setDogFilter(false);
          break;
      }
      this.applyFilters();
    },
    applyFilters() {
      this.setClassesFilter(this.classModel);
      this.setSystemFilter(
        !!this.systemModel
          ? systemsEnum.find((s) => s.system === this.systemModel)
          : null
      );
      this.$emit("applyFilters");
    },
    setClass(val) {
      this.classModel =
        val === undefined || val === null
          ? null
          : this.classesListComputed[val];
    },
    setSystem(val) {
      this.systemModel =
        val === undefined || val === null ? null : this.systemsList[val];
    },
  },
  data() {
    return {
      mdiCloseCircleOutline,
      mdiChevronDown,
      dialogClassModel: false,
      dialogSystemsModel: false,
      dialogAnimalsModel: false,
      classModel: null,
      systemModel: null,
      clearTrigger: 0,
      clearTriggerSystem: 0,
      mdiMagnify,
      searchCondition: "",
    };
  },
};
</script>
